import { Button, DataTable } from 'shared/components/ui';
import React from 'react';
import { useSortableTable } from '../../../shared/hooks/useSortableTable';
import useDragScroll from '../../../shared/hooks/useDragScroll';
import { StatusBadge } from '../../../shared/components';
import './TablaFacturacionTecnicos.css';

const ESTADOS_FACTURABLES = ['realizado', 'listo para enviar', 'enviado', 'facturado', 'escoreado', 'escoreado / muestras en carpeta', 'en proceso', 'solicitado'];

const TablaFacturacionTecnicos = ({ datos, titulo, onToggleFacturado, onToggleAll, onVerAdjuntos, onCambiarAuditoria, estadosTurno, isAdmin, esMedicos, mes, anio, botonesSeleccion }) => {
  const { sortedData, sortConfig, requestSort } = useSortableTable(datos);
  const { ref: dragRef, onMouseDown, onMouseUp, onMouseMove, onMouseLeave } = useDragScroll();
  const esResumen = datos.length > 0 && datos[0]?.cantidad !== undefined && !datos[0]?.idTurno;

  const getEstadoColor = (estado) => {
    const estadoLower = estado?.toLowerCase() || '';
    if (estadoLower.includes('cancelado') || estadoLower.includes('no realizado')) return 'danger';
    if (estadoLower.includes('realizado') || estadoLower.includes('enviado')) return 'success';
    if (estadoLower.includes('repetir')) return 'warning';
    return 'secondary';
  };

  const getSortIcon = (columnName) => {
    if (sortConfig?.key !== columnName) return '⇅';
    return sortConfig.direction === 'asc' ? '↑' : '↓';
  };

  if (esResumen) {
    return (
      <div className="tabla-facturacion-tecnicos">
        <h3>{titulo}</h3>
        <div className="table-responsive" ref={dragRef} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} style={{ cursor: 'grab' }}>
          <DataTable className="table">
            <thead>
              <tr>
                <th>Nro</th>
                <th onClick={() => requestSort(esMedicos ? 'medico' : 'tecnico')}>
                  {esMedicos ? 'Médico' : 'Técnico'} {getSortIcon(esMedicos ? 'medico' : 'tecnico')}
                </th>
                <th onClick={() => requestSort('mes')}>
                  Mes {getSortIcon('mes')}
                </th>
                <th onClick={() => requestSort('anio')}>
                  Año {getSortIcon('anio')}
                </th>
                <th onClick={() => requestSort('cantidad')}>
                  Cantidad {getSortIcon('cantidad')}
                </th>
                <th onClick={() => requestSort('importe')}>
                  Importe {getSortIcon('importe')}
                </th>
                <th>Factura</th>
                <th>Comprobante</th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{esMedicos ? item.medico : item.tecnico}</td>
                  <td className="text-center">{item.mes || mes || '-'}</td>
                  <td className="text-center">{item.anio || anio || '-'}</td>
                  <td className="text-center">{item.cantidad}</td>
                  <td className="text-right">${parseFloat(item.importe || 0).toFixed(2)}</td>
                  <td className="text-center">
                    {item.adjuntoFactura ? (
                      <Button
                        className="btn btn-sm btn-primary" 
                        onClick={() => onVerAdjuntos?.(item, 'factura')}
                      >
                        Ver Factura
                      </Button>
                    ) : (
                      <span className="text-muted">Sin factura</span>
                    )}
                  </td>
                  <td className="text-center">
                    <Button
                      className="btn btn-sm btn-primary" 
                      onClick={() => onVerAdjuntos?.(item, 'comprobante')}
                    >
                      {item.adjuntoComprobante ? 'Ver Comprobante' : 'Subir Comprobante'}
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </DataTable>
        </div>
      </div>
    );
  }

  return (
    <div className="tabla-facturacion-tecnicos">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
        <h3 style={{ margin: 0 }}>{titulo}</h3>
        {botonesSeleccion}
      </div>
      <div className="table-responsive" ref={dragRef} onMouseDown={onMouseDown} onMouseUp={onMouseUp} onMouseMove={onMouseMove} onMouseLeave={onMouseLeave} style={{ cursor: 'grab' }}>
        <DataTable className="table">
          <thead>
            <tr>
              <th>Nro</th>
              <th onClick={() => requestSort('idTurno')}>
                # {getSortIcon('idTurno')}
              </th>
              <th onClick={() => requestSort('persona.apellido')}>
                Apellido {getSortIcon('persona.apellido')}
              </th>
              <th onClick={() => requestSort('persona.nombre')}>
                Nombre {getSortIcon('persona.nombre')}
              </th>
              <th onClick={() => requestSort('centro')}>
                Centro {getSortIcon('centro')}
              </th>
              <th onClick={() => requestSort('fechaEstudio')}>
                F.Estudio {getSortIcon('fechaEstudio')}
              </th>
              {esMedicos && (
                <th onClick={() => requestSort('fechaProcesado')}>
                  Fecha Procesado {getSortIcon('fechaProcesado')}
                </th>
              )}
              {!esMedicos && <th>Técnico</th>}
              <th onClick={() => requestSort('estado')}>
                Estado {getSortIcon('estado')}
              </th>
              <th onClick={() => requestSort('practica')}>
                Práctica {getSortIcon('practica')}
              </th>
              <th onClick={() => requestSort('importe')}>
                Importe {getSortIcon('importe')}
              </th>
              {isAdmin && onCambiarAuditoria && <th>Auditoría</th>}
              <th onClick={() => requestSort('urgente')}>
                Urgente {getSortIcon('urgente')}
              </th>
              <th onClick={() => requestSort('estaFacturado')}>
                Facturado {getSortIcon('estaFacturado')}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedData.map((turno, index) => {
              const estadoOriginal = turno.estadosTurno?.estadoTurno || turno.realizo || turno.estado || turno.estadoTurno || 'Sin estado';
              const estado = turno.auditoria || estadoOriginal;
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{turno.idTurno}</td>
                  <td>{turno.persona?.apellido || turno.apellido || '-'}</td>
                  <td>{turno.persona?.nombre || turno.nombre || '-'}</td>
                  <td>{turno.centro?.centro1 || turno.centro || '-'}</td>
                  <td>{turno.f_Estudio || turno.fechaEstudio || turno.horario?.inicio?.split('T')[0] || '-'}</td>
                  {esMedicos && <td>{turno.fechaModifListoParaEnviarMedico?.split('T')[0] || '-'}</td>}
                  {!esMedicos && <td>{turno.tecnico || turno.realizo || '-'}</td>}
                  <td>
                    <StatusBadge 
                      status={estado} 
                      variant={getEstadoColor(estado)}
                    />
                  </td>
                  <td>{turno.practica || turno.tipoEstudio?.tipoEstudio || '-'}</td>
                  <td className="text-right">
                    ${parseFloat(turno.importe || turno.importeTecnico || 0).toFixed(2)}
                  </td>
                  {isAdmin && onCambiarAuditoria && (
                    <td>
                      <select
                        className="select-auditoria"
                        value={estado}
                        onChange={(e) => onCambiarAuditoria(turno.idTurno, e.target.value)}
                      >
                        <option value={estado}>{estado}</option>
                        {estadosTurno
                          ?.filter(et => et.estadoTurno !== estado)
                          .map(et => (
                            <option key={et.idEstadoTurno} value={et.estadoTurno}>{et.estadoTurno}</option>
                          ))}
                      </select>
                    </td>
                  )}
                  <td className="text-center">
                    {turno.urgente
                      ? <span style={{ background: '#dc3545', color: '#fff', padding: '2px 8px', borderRadius: '4px', fontSize: '0.75rem', fontWeight: 600 }}>
                          {esMedicos ? 'URGENTE +30%' : 'URGENTE'}
                        </span>
                      : <span style={{ color: '#aaa', fontSize: '0.75rem' }}>—</span>
                    }
                  </td>
                  <td className="text-center">
                    <input 
                      type="checkbox" 
                      checked={turno.estaFacturado} 
                      onChange={() => onToggleFacturado?.(turno.idTurno)}
                      disabled={!isAdmin || estado?.toLowerCase().includes('repetir') || !ESTADOS_FACTURABLES.includes(estado?.toLowerCase())}
                    />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </DataTable>
      </div>
    </div>
  );
};

export default TablaFacturacionTecnicos;
